/*!
=========================================================
* Header used on all pages (except login, password reset, profile).
=========================================================
*/
import React, { useContext } from "react";

// reactstrap components
import {
    Container,
} from "reactstrap";
//classes
import WbSession from "classes/Session.jsx";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/pro-solid-svg-icons';

function SimpleHeader() {
    const session = useContext( WbSession );
    
    return (
        <>
            <div className="frontend-header pb-6">
            </div>
        </>
    );
}

export default SimpleHeader;
